import { createElementIdSlice } from '../utils/action/createElementSlice';
export const TableState = createElementIdSlice({
    elementName: 'table',
    initialState: {},
    reducers: {},
});
